import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Association } from '../../../../../../../../../models/association';

@Component({
  selector: 'app-check-in-no-entry-method-modal',
  templateUrl: './check-in-no-entry-method-modal.component.html',
  styleUrls: ['./check-in-no-entry-method-modal.component.css']
})
export class CheckInNoEntryMethodModalComponent implements OnInit {

  @Input() customerId: number;
  @Input() association: Association;
  @Input() provideFreeEntryCallback: (freeEntryReason: string) => undefined;

  public freeEntryReason = '';

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
  }

}
